var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseButtonRow',{attrs:{"buttons":_vm.buttons,"justify":_vm.justify,"is-valid":_vm.isValid},on:{"cancel":function($event){return _vm.$emit('cancel')}}})}
var staticRenderFns = []

export { render, staticRenderFns }